export enum UserReportReasonEnum {
    CheatingWithAnotherPlayer = 1,
    AbusingChat = 2,
    InappropriateUsername = 3,
    WastingTime = 4,
    Griefing = 5,
    ThrowingTheGame = 6,
}

export enum PieceTypes {
    City, Settlement, Road, DevelopmentCard, Ship, CityWall, Knight,
}

// Dec 5, 2020. This is a placeholder until the room design is done
export enum TemporaryModeSettingEnum {
    TutorialClassic,
    Classic,
    Seafarers,
    CitiesAndKnights,
    CitiesAndKnightsSeafarers,
    Inactive,
    ServerStressTest,
}
